import React from 'react';
import { Box, Divider, SvgIcon, Typography, useTheme } from '@mui/material';
import { FundTrackRecord } from '../../../../models/Fund';
import { useTranslation } from 'react-i18next';
import { Utilities } from '../../../../utility/utils';
import { ReactComponent as pigIcon } from '../../../../assets/pig.svg';
import { ReactComponent as stackIcon } from '../../../../assets/stack_light.svg';
import { ReactComponent as calendarIcon } from '../../../../assets/calendar_2.svg';
import { ReactComponent as moneyIcon } from '../../../../assets/money_2.svg';
import { ReactComponent as buildingIcon } from '../../../../assets/building.svg';
import { LeoImagesCompagniesPath } from '../../../../resources/api-constants';

export interface ITrackRecordsListItemProps {
  trackRecord: FundTrackRecord;
}
const TrackRecordsListItem: React.FC<ITrackRecordsListItemProps> = ({ trackRecord }) => {
  const { t } = useTranslation();
  const theme = useTheme();


  const renderTrackRecordValue = (name: string, value: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>): React.ReactNode => {
    return <Box display={"flex"} alignItems={"flex-start"} flexBasis={"40%"} flexGrow={1} gap={"15px"}>
      <SvgIcon component={icon} inheritViewBox style={{ width: "36px", height: "36px", color : theme.palette.primary.dark }} />
      <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} gap={"4px"}>
        <Typography fontSize={"14px"} fontWeight={"400"} lineHeight={"17.07px"}>{name}</Typography>
        <Typography fontSize={"16px"} fontWeight={"600"} lineHeight={"19.5px"}>{value}</Typography>
      </Box>
    </Box>
  }

  return <Box display={"flex"} flexDirection={"column"} gap={"14px"}>
    <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"}>{trackRecord.name}</Typography>
    <Divider />
    <Box display={"flex"} alignItems={"flex-start"}>
      <Box display={"flex"} flexWrap={"wrap"} flexBasis={"66%"} flexGrow={1} gap={"33px"}>
        {renderTrackRecordValue(t("LibraryOfFundTrackRecordsTabSize"), `€${Utilities.toFriendlyMoneyValue(trackRecord.size)}`, pigIcon)}
        {renderTrackRecordValue(t("PortfolioPageItemTVPI"), `${trackRecord.tvpi.toFixed(1)}`, stackIcon)}
        {renderTrackRecordValue(t("LibraryOfFundTrackRecordsTabVintageYear"), `${trackRecord.vintageYear}`, calendarIcon)}
        {renderTrackRecordValue(t("PortfolioPageItemDPI"), `${trackRecord.dpi.toFixed(1)}`, moneyIcon)}
      </Box>
      <Box display={"flex"} alignItems={"center"} flexBasis={"33%"} flexGrow={1} gap={"15px"}>
        <SvgIcon component={buildingIcon} inheritViewBox style={{ width: "36px", height: "36px" }} />
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"}>
          <Typography fontSize={"14px"} fontWeight={"400"} lineHeight={"17.07px"}>{t('LibraryOfFundTrackRecordsTabNotableCompanies')}</Typography>
          <Box display={"flex"}>
            {trackRecord.notableCompagnies.map(c => <img src={`${LeoImagesCompagniesPath}/${c.logo}`} key={`notablecompany-${trackRecord.id}-${c.id}`} />)}
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
}

export default TrackRecordsListItem